import { Component, EventEmitter, Output } from '@angular/core';
import { NgFor, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OrderStatus } from '../../models/order';
@Component({
  selector: 'app-order-info',
  imports: [ FormsModule],
  templateUrl: './order-info.html',
  styleUrl: './order-info.scss'
})
export class OrderInfo {
  @Output() filterChange = new EventEmitter<string>();

  selectedFilter: OrderStatus = OrderStatus.ALL;
  protected orderStatus = OrderStatus

  onFilterChange(value: OrderStatus) {
    this.selectedFilter = value;
    this.filterChange.emit(value);
  }
}
